import {useItemsDashboard} from '@kit';

import React from 'react';

import {Layout} from '../../components/layout';
import {NotFoundSeo, SectionSeo} from '../../lib/seo';
import {getApolloError, cls} from '../../components/utils';
import {useRoute} from '../../lib/routes';
import {SpecieView} from './view';
import {useSpeciesQuery} from '../../generated/types';

import css from '@kit/sidebar/dashboard.module.css';
import pageCss from '../../components/common.module.css';

type Props = {};

export const SpeciePage: React.FC<Props> = () => {
	const {data, loading, error} = useSpeciesQuery({
		ssr: true,
	});

	const router = useRoute();
	const query = router?.query || {};

	const {selectedId, selected, showView, handleBack, Sidebar, notFound} = useItemsDashboard({
		items: data?.species || [],
		id: query.id as string,
		loading,
		route: 'specie',
		baseRoute: 'species',
		sidebarHeader: (specie) => specie.title,
	});

	const title = showView && selected ? selected.title : 'Расы';

	return (
		<Layout handleBack={selected && handleBack}>
			{!selectedId && <SectionSeo section="species" />}
			{notFound && <NotFoundSeo />}
			<div className={css.dashboard}>
				{error ? (
					<div className={pageCss.fullSizeBlock}>{getApolloError(error).message}</div>
				) : (
					<div className={cls(css.dashboardWrapper, showView && css.showView)}>
						<div className={css.sidebar}>{Sidebar}</div>
						<div className={css.view}>
							{selectedId && showView ? (
								<SpecieView specieId={selectedId} title={title} />
							) : (
								<div className={pageCss.fullSizeBlock}>Выберите вид</div>
							)}
						</div>
					</div>
				)}
			</div>
		</Layout>
	);
};
